module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "historyRecord choose-yet no-record-yet"
  }, [_c('h1', {
    staticClass: "historyRecord_title"
  }, [_vm._v("\n        共找到 " + _vm._s(_vm.total) + " 辆车 \n        "), _c('a', {
    staticClass: "choose_clear",
    attrs: {
      "href": "/buy.htm?store=none&city=none",
      "click_type": "List-clear-all"
    }
  }, [_vm._v("清除筛选条件")])]), _vm._v(" "), _c('div', {
    staticClass: "choose_condition"
  }, [_c('div', {
    staticClass: "choose_items clearfix"
  }, _vm._l((_vm.choose_items), function(item) {
    return _c('div', {
      staticClass: "choose_item"
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n                "), _c('a', {
      on: {
        "click": function($event) {
          _vm.removeCondition(item.key)
        }
      }
    }, [_c('span', [_vm._v("x")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "list_waring hidden"
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "historyRecord_content"
  }, [_c('ul')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a0beb78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/NavContainer/HistoryRecord.vue
// module id = 866
// module chunks = 5